import { render, staticRenderFns } from "./magicLink.vue?vue&type=template&id=7583e125&scoped=true"
import script from "./magicLink.vue?vue&type=script&lang=js"
export * from "./magicLink.vue?vue&type=script&lang=js"
import style0 from "./magicLink.vue?vue&type=style&index=0&id=7583e125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7583e125",
  null
  
)

export default component.exports